module.exports = __webpack_public_path__ + "img/exam-placeholder-img.98f59d02.png";